class Share {
	constructor() {
		// розміри вікна
		this._vw = window.innerWidth;
		this._vh = window.innerHeight;

		// параметри вікна, в якому відкриється розшарювання
		this._p1 = `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600,left=${(this.vw-600)/2},top=${(this.vh-600)/2}`;
		this._p2 = `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=700,width=1024,left=${(this.vw-1024)/2},top=${(this.vh-700)/2}`;

		// масив із кнопок
		this._links = [];

		// загальний селектор для всіх кнопок шари
		// TODO: можливо додати це поле як вхідні дані для класу
		this._selector = '.sharelink';

		this.init();
	}

	get selector() {
		return this._selector;
	}

	get p1() {
		return this._p1;
	}

	get p2() {
		return this._p2;
	}

	get vw() {
		return this._vw;
	}

	get vh() {
		return this._vh;
	}

	init() {
		let b = document.querySelectorAll(this.selector);

		if(b.length) {
			for(let i = 0; i < b.length; i++) {
				let _this = this;

				b[i].addEventListener('click', function(e) {
					e.preventDefault();

					if(b[i].classList.contains('facebook')) {
						window.open(
							`https://www.facebook.com/sharer/sharer.php?u=${this['getAttribute']('data-share-url')}`,
							'', _this.p1
						);
						return false;
					}
					else if(b[i].classList.contains('twitter')) {
						window.open(
							`https://twitter.com/home?status=${this['getAttribute']('data-share-url')}`,
							'', _this.p1
						);
						return false;
					}
					else if(b[i].classList.contains('googleplus')) {
						window.open(
							`https://plus.google.com/share?url=${this['getAttribute']('data-share-url')}`,
							'', _this.p1
						);
						return false;
					}
					else if(b[i].classList.contains('linkedin')) {
						window.open(
							`https://www.linkedin.com/shareArticle?mini=true&url=${this['getAttribute']('data-share-url')}`,
							'', _this.p2
						);
						return false;
					}
					else {
						console.warn('Unknown share button.');
					}
				})
			}
		}
	}
}

module.exports = Share;



// WEBPACK FOOTER //
// ./entries/classes/Share.js